
export function addLabel(feature, layer, isPermanent, labelField) {
    if (
      feature.properties &&
      feature.geometry
    ) {
      const label = (labelField && typeof feature.properties[labelField] !== 'undefined') ? feature.properties[labelField] : feature.properties.name + (feature.properties['name:ga'] ? ' (' + feature.properties['name:ga'] + ')' : '')
      if (label !== 'undefined') {
        layer.bindTooltip(label, {
          className: 'area-label-tooltip',
          sticky: true,
          permanent: isPermanent
        });
      }
    }
  }
  
  /**
   * Increase the opacity by factor of 1.5 when you hover over it
   * @param {*} layer 
   */
  
  function addHoverBehaviour(layer, config) {
    var currentOpacity;
    layer.on('mouseover', () => {
      if (layer.feature.geometry.type !== 'LineString') {
        currentOpacity = layer.options.fillOpacity;
        layer.setStyle({ fillOpacity: currentOpacity * 1.5, weight: 1 });
      }
    });
    layer.on('mouseout', () => {
      if (typeof config.style !== 'undefined') {
        layer.setStyle(config.style);
      } else {
        layer.setStyle({ fillOpacity: currentOpacity, weight: 0.5 });
  
      }
    });
  }
  
  export function setAreaBehaviour(permanent, labelField, config) {
    return function (feature, layer) {
      addLabel(feature, layer, permanent, labelField);
      addHoverBehaviour(layer, config);
    };
  }
  